import React from "react";
import PropTypes from "prop-types";
import { withStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import NotFoundTableRow from "../NotFoundTableRow";
import {LABELS as _LABELS} from "../../language";

const LABELS=_LABELS.settingPage;



const styles = theme => ({
    root: {
        width: "98%",
        marginRight: "auto",
        marginLeft: "auto",
        marginTop: theme.spacing(1),
        overflowX: "auto"
    },
    table: {
        minWidth: 700
    },
    tableHead: {
        // padding: 5,
        // minWidth: 130
    },
    tableRowTitle: {
        display: "inline-block"
        // width: 95
    },
    capitalize: {
        textTransform: "capitalize"
    },
    saveIcon: {
        color: "#009be5",
        cursor: "pointer"
    },
    time: {
        minWidth: "125px"
    }
});

class ReduxTableRow extends React.Component {
    handleAssign = (e, item) => {
        this.props.handleAssignDriver(e, item);
    };

    render() {
        const { classes, item = {} } = this.props;

        return (
            <TableRow hover>
                <TableCell>
                    <div className={classes.capitalize}>
                        {item.user && (
                            <div>
                                {item.user.firstName} {item.user.lastName}
                            </div>
                        )}
                    </div>
                </TableCell>
                <TableCell>
                    <div className={classes.capitalize}>
                        <div>{item.title}</div>
                    </div>
                </TableCell>
                <TableCell>
                    <div className={classes.capitalize}>
                        <div>{item.body}</div>
                    </div>
                </TableCell>
                <TableCell>
                    <div>{this.props.formatDate(item.created)}</div>
                    <div>{this.props.formatTime(item.created)}</div>
                </TableCell>
            </TableRow>
        );
    }
}

export class ReduxTable extends React.Component {
    state = {
        order: "asc"
    };

    handleChangePage = (event, page) => {
        const { limit } = this.props;
        this.props.handleChange({ page, limit });
    };

    handleChangeRowsPerPage = event => {
        const limit = event.target.value;
        const { page } = this.props;
        this.props.handleChange({ page, limit });
    };

    render() {
        const { classes, items = [], count = 1000 } = this.props;
        const { page, limit } = this.props;

        return (
            <Paper className={classes.root}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>{LABELS.driver}</TableCell>
                            <TableCell>{LABELS.title}</TableCell>
                            <TableCell>{LABELS.body}</TableCell>
                            <TableCell className={classes.time}>{LABELS.time}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Array.isArray(items) &&
                            items.map((item, i) => (
                                <ReduxTableRow
                                    item={item}
                                    key={i}
                                    classes={classes}
                                    formatDate={this.props.formatDate}
                                    formatTime={this.props.formatTime}
                                    handleAssignDriver={
                                        this.props.handleAssignDriver
                                    }
                                />
                            ))}
                    </TableBody>
                </Table>
                <NotFoundTableRow items={items} />
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50, 100, 500, 1000]}
                    component="div"
                    count={count}
                    rowsPerPage={limit}
                    page={page}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                    labelRowsPerPage={LABELS.rowsperpage}
                />
            </Paper>
        );
    }
}

ReduxTable.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ReduxTable);
